const filters = document.querySelector('section.tag-buttons');

function scrollEventThrottle(fn) {
  let last_known_scroll_position = 0;
  let ticking = false;
  
  window.addEventListener("scroll", function () {
    let previous_known_scroll_position = last_known_scroll_position;
    last_known_scroll_position = window.scrollY;
    if (!ticking) {
      window.requestAnimationFrame(function () {
        fn(last_known_scroll_position, previous_known_scroll_position);
        ticking = false;
      });
      ticking = true;
    }
  });
}

scrollEventThrottle((scrollPos, previousScrollPos) => {
  if (previousScrollPos > scrollPos) {
    filters.classList.add('extend-top');
  }else {
    if(filters.classList.contains('extend-top')){
      filters.classList.remove('extend-top');
    }
  }
});


document.addEventListener("DOMContentLoaded", function() {
  const url = window.location.href,
        section = url.split('#')[1],
        button = document.querySelector('.filter-button.flavor[data-filter="'+ section +'"');

  if(button){
    button.click();
  }
});

const accordions = document.querySelectorAll('.accordion');

function closeAllAccordions() {
  accordions.forEach(accordion => {
    const header = accordion.querySelector('.accordion-header');
    const content = accordion.querySelector('.accordion-content');
    header.setAttribute('aria-expanded', 'false');
    content.style.display = 'none';
  });
}
accordions.forEach(accordion => {
  const header = accordion.querySelector('.accordion-header');
  const content = accordion.querySelector('.accordion-content');
  const span = header.querySelector('span');

  function toggleAccordion(event) {
    event.preventDefault(); //prevent default behavior for touch events
    const isExpanded = header.getAttribute('aria-expanded') === 'true';
    closeAllAccordions();
    header.setAttribute('aria-expanded', String(!isExpanded));
    content.style.display = isExpanded ? 'none' : 'flex';
  }

  //touchstart for mobile devices
  if ('ontouchstart' in window) {
    header.addEventListener('touchstart', toggleAccordion);
  } else {
    header.addEventListener('mouseenter', toggleAccordion);
  }

  // keyboard events
  header.addEventListener('keydown', event => {
    if (event.key === 'Enter' || event.key === ' ') {
      event.preventDefault();
      header.click();
    }
  });
});

document.addEventListener('click', event => {
  const isAccordionHeader = event.target.classList.contains('accordion-header');
  const isAccordionContent = event.target.closest('.accordion-content');
  if (!isAccordionHeader && !isAccordionContent) {
    closeAllAccordions();
  }
});